import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Package, Search } from "lucide-react";

export default function POSStock() {
  const [rows, setRows] = useState([]);
  const [q, setQ] = useState("");
  const [loading, setLoading] = useState(false);
  const load = () => {
    setLoading(true);
    api.get("/pos/stock", { params: { search: q || undefined } })
      .then((r) => setRows(r.data || []))
      .finally(() => setLoading(false));
  };
  useEffect(() => { load(); }, []);
  return (
    <div className="p-4 space-y-3 max-w-5xl mx-auto">
      <div className="bg-white rounded-lg border border-slate-200 p-3 flex items-center gap-2">
        <Package className="h-5 w-5 text-red-600" />
        <h2 className="text-lg font-semibold flex-1">Current Stock</h2>
        <div className="relative w-64"><Search className="h-4 w-4 absolute left-2.5 top-1/2 -translate-y-1/2 text-slate-400" /><Input value={q} onChange={(e) => setQ(e.target.value)} onKeyDown={(e) => e.key === "Enter" && load()} className="pl-8" placeholder="Product / SKU…" data-testid="pos-stock-search" /></div>
      </div>
      <div className="bg-white rounded-lg border border-slate-200 overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-slate-50"><tr className="text-left text-[11px] uppercase tracking-widest text-slate-500"><th className="px-3 py-2">Product</th><th className="px-3 py-2">SKU</th><th className="px-3 py-2">HSN</th><th className="px-3 py-2 text-right">Qty</th><th className="px-3 py-2">Last Movement</th></tr></thead>
          <tbody className="divide-y divide-slate-100">
            {loading && <tr><td colSpan={5} className="px-3 py-10 text-center text-slate-400">Loading…</td></tr>}
            {!loading && rows.length === 0 && <tr><td colSpan={5} className="px-3 py-10 text-center text-slate-400">No stock rows.</td></tr>}
            {rows.map((r) => (
              <tr key={r.product_id} className="hover:bg-slate-50">
                <td className="px-3 py-2 font-medium">{r.product_name}</td>
                <td className="px-3 py-2 font-mono text-xs">{r.product_sku}</td>
                <td className="px-3 py-2 font-mono text-xs">{r.hsn_code || "—"}</td>
                <td className="px-3 py-2 text-right font-semibold tabular-nums">{r.qty}</td>
                <td className="px-3 py-2 text-xs text-slate-500">{r.last_movement_at ? new Date(r.last_movement_at).toLocaleString() : "—"}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
